'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.socketConnectedSelector = exports.getSocketConnectionStatus = exports.getSocketConnection = undefined;

var _reselect = require('reselect');

var _socketConstants = require('./socketConstants');

// Lib
var getSocketConnection = exports.getSocketConnection = function getSocketConnection(state) {
    return state.getIn(['app', 'socketConnection']);
};

// Constants
var getSocketConnectionStatus = exports.getSocketConnectionStatus = function getSocketConnectionStatus(state) {
    return state.getIn(['app', 'socketConnection', 'status']);
};

var socketConnectedSelector = exports.socketConnectedSelector = (0, _reselect.createSelector)(getSocketConnectionStatus, function (socketStatus) {
    return socketStatus === _socketConstants.SOCKET_CONNECTION_STATUS.CONNECTED;
});


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/socket/socketConnectionSelector.js
// module id = 768
// module chunks = 0